// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz
// tefat-product-page.js

var syncQuantityInputs = function(sourceInput) {
    var form = sourceInput.closest('form');
    if (!form) return;
    var allInputs = form.querySelectorAll('.tefat-produkt__antal-input');
    allInputs.forEach(function(inp) {
      if (inp !== sourceInput) inp.value = sourceInput.value;
    });
    var mainInput = form.querySelector('[data-quantity-input]');
    if (mainInput && mainInput !== sourceInput) mainInput.value = sourceInput.value;
  };

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.tefat-produkt__antal-btn');
    if (!btn) return;

    var wrapper = btn.closest('.tefat-produkt__antal-wrapper');
    if (!wrapper) return;

    var input = wrapper.querySelector('.tefat-produkt__antal-input');
    if (!input) return;

    e.preventDefault();

    var action = btn.dataset.action;
    var currentValue = parseInt(input.value) || 1;
    var min = parseInt(input.min) || 1;
    var max = input.max ? parseInt(input.max) : Number.POSITIVE_INFINITY;

    if (action === 'increase' && currentValue < max) input.value = currentValue + 1;
    if (action === 'decrease' && currentValue > min) input.value = currentValue - 1;

    syncQuantityInputs(input);
  });

  document.addEventListener('input', function(e) {
    if (!e.target.matches('.tefat-produkt__antal-input')) return;
    syncQuantityInputs(e.target);
  });

  var getFlightSvgForTier = function(variant, tier) {
    if (!variant || !variant.metafields) return null;
    var key = 'flight_svg_' + tier;
    return variant.metafields[key] || variant.metafields.flight_svg_default || null;
  };

  var applyFlightTier = function(diagram, tier, variant) {
    if (!diagram) return;
    var img = diagram.querySelector('[data-flight-graph]');
    var toggles = diagram.querySelectorAll('[data-flight-toggle]');
    toggles.forEach(function(t) {
      var isActive = t.dataset.flightToggle === tier;
      t.classList.toggle('tefat-produkt__flight-label--aktiv', isActive);
      t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    diagram.dataset.flightActiveTier = tier;
    if (!img) return;
    var src = getFlightSvgForTier(variant, tier) || img.dataset.flightDefaultSrc;
    if (src && img.src !== src) img.src = src;
  };

  document.addEventListener('click', function(e) {
    var toggleBtn = e.target.closest('[data-flight-toggle]');
    if (!toggleBtn) return;
    var diagram = toggleBtn.closest('[data-flight-diagram]');
    if (!diagram) return;
    e.preventDefault();
    var section = diagram.closest('.tefat-produkt[data-section-id]');
    var variant = null;
    if (section && window.__tefatProductData && window.__tefatProductData[section.dataset.sectionId]) {
      var data = window.__tefatProductData[section.dataset.sectionId];
      var sel = document.getElementById('variant-select-' + section.dataset.sectionId);
      if (sel && data.variants) variant = data.variants.find(function(v){ return String(v.id) === String(sel.value); });
    }
    applyFlightTier(diagram, toggleBtn.dataset.flightToggle, variant);
  });

  document.addEventListener('DOMContentLoaded', function() {
    var galleri = document.querySelector('.tefat-produkt__galleri');
    var huvudbild = galleri ? galleri.querySelector('.tefat-produkt__bild') : null;
    var mobilGalleri = galleri ? galleri.querySelector('.tefat-produkt__mobil-galleri') : null;
    var thumbnails = galleri ? galleri.querySelectorAll('.tefat-produkt__thumbnail') : [];
    var produktBilder = [];
    var aktivIndex = 0;

    var scrollMobilGalleri = function(index) {
      if (!mobilGalleri || mobilGalleri.offsetParent === null || !mobilGalleri.clientWidth) return;
      mobilGalleri.scrollTo({ left: index * mobilGalleri.clientWidth, behavior: 'instant' in mobilGalleri ? 'instant' : 'auto' });
    };
    
    if (galleri && huvudbild) {
      var zoomBtn = galleri.querySelector('.tefat-produkt__zoom');
      
      var mediaSectionId = galleri.dataset.sectionMedia;
      var mediaDataEl = mediaSectionId ? document.getElementById('media-data-' + mediaSectionId) : null;
      try {
        produktBilder = mediaDataEl ? JSON.parse(mediaDataEl.textContent) : [];
      } catch (err) {
        console.warn('Kunde inte parsa produktbilder:', err);
      }
      
      aktivIndex = 0;
      var initialSrc = huvudbild.getAttribute('src') || '';
      for (var i = 0; i < produktBilder.length; i++) {
        if (produktBilder[i].src && initialSrc.indexOf(produktBilder[i].src.split('?')[0].split('/').pop()) !== -1) {
          aktivIndex = i;
          break;
        }
      }
      
      thumbnails.forEach(function(thumb) {
        thumb.classList.toggle('tefat-produkt__thumbnail--aktiv', parseInt(thumb.dataset.index, 10) === aktivIndex);
      });

      var visaBild = function(index) {
        if (!produktBilder.length) return;
        index = ((index % produktBilder.length) + produktBilder.length) % produktBilder.length;
        if (index === aktivIndex || !produktBilder[index]) return;

        thumbnails.forEach(function(t) { t.classList.remove('tefat-produkt__thumbnail--aktiv'); });
        if (thumbnails[index]) thumbnails[index].classList.add('tefat-produkt__thumbnail--aktiv');

        huvudbild.style.opacity = '0';
        setTimeout(function() {
          huvudbild.src = produktBilder[index].src;
          huvudbild.srcset = produktBilder[index].srcset;
          huvudbild.alt = produktBilder[index].alt;
          requestAnimationFrame(function() { huvudbild.style.opacity = '1'; });
        }, 150);

        aktivIndex = index;
        scrollMobilGalleri(index);
      };

      thumbnails.forEach(function(thumb, index) {
        thumb.addEventListener('click', function() { visaBild(index); });
      });

      // Mobile gallery is a native horizontal scroll-snap strip (no JS swipe).
      // For zoom, resolve the image currently snapped into view.
      var aktuellBild = function() {
        if (mobilGalleri && mobilGalleri.offsetParent !== null && mobilGalleri.clientWidth) {
          var idx = Math.round(mobilGalleri.scrollLeft / mobilGalleri.clientWidth);
          var bilder = mobilGalleri.querySelectorAll('.tefat-produkt__mobil-bild');
          if (bilder[idx]) return { src: bilder[idx].currentSrc || bilder[idx].src, alt: bilder[idx].alt };
        }
        return { src: huvudbild.src, alt: huvudbild.alt };
      };

      if (zoomBtn) {
        var zoomOverlay = document.querySelector('.tefat-zoom-overlay');
        
        if (!zoomOverlay) {
          zoomOverlay = document.createElement('div');
          zoomOverlay.className = 'tefat-zoom-overlay';
          zoomOverlay.innerHTML = '<div class="tefat-zoom-overlay__content"><img src="" alt="" class="tefat-zoom-overlay__bild"></div>';
          document.body.appendChild(zoomOverlay);
        }
        
        var zoomBild = zoomOverlay.querySelector('.tefat-zoom-overlay__bild');
        
        var openZoom = function() {
          var bild = aktuellBild();
          zoomBild.src = bild.src;
          zoomBild.alt = bild.alt;
          zoomOverlay.classList.add('tefat-zoom-overlay--aktiv');
          document.body.style.overflow = 'hidden';
          if (window.lenis) window.lenis.stop();
        };
        
        var closeZoom = function() {
          zoomOverlay.classList.remove('tefat-zoom-overlay--aktiv');
          document.body.style.overflow = '';
          if (window.lenis) window.lenis.start();
        };
        
        zoomBtn.addEventListener('click', openZoom);
        zoomOverlay.addEventListener('click', closeZoom);
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && zoomOverlay.classList.contains('tefat-zoom-overlay--aktiv')) {
            closeZoom();
          }
        });
      }
    }
    
    /* ========================================
       PRODUKTFORMULÄR - AJAX ADD TO CART
       ======================================== */
    
    const section = document.querySelector('.tefat-produkt[data-section-id]');
    if (!section) return;
    
    const sectionId = section.dataset.sectionId;
    const productDataEl = document.getElementById('product-data-' + sectionId);
    const form = document.getElementById('product-form-' + sectionId);
    
    if (!productDataEl || !form) return;
    
    const variantSelect = document.getElementById('variant-select-' + sectionId);
    const quantityInput = document.getElementById('quantity-' + sectionId);
    const priceEl = document.getElementById('price-' + sectionId);
    const addToCartBtn = document.getElementById('add-to-cart-' + sectionId);
    const addToCartBtnMobile = form.querySelector('[data-add-to-cart-mobile]');
    const allAddToCartBtns = [addToCartBtn, addToCartBtnMobile].filter(Boolean);
    const feedbackEl = document.getElementById('form-feedback-' + sectionId);
    
    const productData = JSON.parse(productDataEl.textContent);
    window.__tefatProductData = window.__tefatProductData || {};
    window.__tefatProductData[sectionId] = productData;
    const flightDiagram = section.querySelector('[data-flight-diagram]');
    if (flightDiagram) {
      const initialVariant = productData.variants.find(function(v){ return String(v.id) === String((document.getElementById('variant-select-' + sectionId) || {}).value); }) || productData.variants[0];
      applyFlightTier(flightDiagram, flightDiagram.dataset.flightActiveTier || 'r', initialVariant);
    }

    const variantUi = form.querySelector('[data-variant-ui="' + sectionId + '"]');
    const variantTrigger = variantUi?.querySelector('.tefat-produkt__variant-trigger');
    const variantDropdown = variantUi?.querySelector('[data-variant-dropdown]');
    const variantLabel = variantUi?.querySelector('.tefat-produkt__variant-label');
    const variantOptions = variantUi ? variantUi.querySelectorAll('.tefat-produkt__variant-option[data-variant-id]') : [];

    const syncVariantUiFromSelect = () => {
      if (!variantUi || !variantLabel || !variantSelect || !variantOptions?.length) return;

      const currentId = variantSelect.value;
      const active = Array.from(variantOptions).find((b) => b.dataset.variantId === currentId);

      variantOptions.forEach((b) => {
        const isActive = b === active;
        b.classList.toggle('tefat-produkt__variant-option--aktiv', isActive);
        b.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (active) variantLabel.innerHTML = active.innerHTML.replace(/\s*–\s*SOLD OUT\s*$/i, '').trim();
    };

    if (variantUi && variantTrigger && variantDropdown && variantOptions.length > 0) {
      syncVariantUiFromSelect();

      const closeDropdown = () => {
        variantUi.dataset.open = 'false';
        variantTrigger.setAttribute('aria-expanded', 'false');
        variantDropdown.setAttribute('aria-hidden', 'true');
      };

      const openDropdown = () => {
        variantUi.dataset.open = 'true';
        variantTrigger.setAttribute('aria-expanded', 'true');
        variantDropdown.setAttribute('aria-hidden', 'false');
      };

      variantUi.dataset.open = 'false';
      variantDropdown.setAttribute('aria-hidden', 'true');

      variantTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = variantUi.dataset.open === 'true';
        if (isOpen) closeDropdown();
        else openDropdown();
      });

      variantOptions.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (!variantSelect) return;
          const targetId = btn.dataset.variantId;
          if (!targetId) return;

          variantSelect.value = targetId;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
          syncVariantUiFromSelect();
          closeDropdown();
        });
      });

      document.addEventListener('pointerdown', (e) => {
        if (!variantUi.contains(e.target)) closeDropdown();
      });
    }
    
    const valutaKod = productData.currency || 'SEK';
    const formatMoney = (variant) => {
      const belopp = variant.price_formatted != null ? variant.price_formatted : String(Math.round(variant.price / 100));
      return valutaKod + ' ' + belopp;
    };
    
    const getVariantById = (id) => {
      return productData.variants.find(v => v.id === parseInt(id));
    };
    
    const formatFlightNumbers = (value) => {
      if (!value) return '';
      if (value.includes('/')) return value;
      return value;
    };

    const formatSpecValue = (value) => {
      if (!value) return '';
      return String(value).replace(/(\d+(?:[.,]\d+)?)|([—–-])|(\s+)/g, (match, num, dash, space) => {
        if (num) return '<span class="spec-number">' + num + '</span>';
        if (dash) return '<span class="spec-dash">' + dash + '</span>';
        if (space) return '<span class="spec-space"> </span>';
        return match;
      });
    };

    const updateMetafieldUI = (variant) => {
      if (!variant || !variant.metafields) return;
      
      const meta = variant.metafields;
      
      const discTypeEl = section.querySelector('[data-metafield="disc_type"]');
      if (discTypeEl && meta.disc_type) {
        discTypeEl.textContent = meta.disc_type;
      }
      
      const flightEl = section.querySelector('[data-metafield="flight_numbers"]');
      if (flightEl && meta.flight_numbers) {
        flightEl.innerHTML = formatFlightNumbers(meta.flight_numbers);
      }
      
      const materialEl = section.querySelector('[data-metafield="material"]');
      if (materialEl && meta.material) {
        materialEl.innerHTML = '<span class="brackets">[</span>&nbsp;' + meta.material + '&nbsp;<span class="brackets">]</span>';
      }
      
      const runEl = section.querySelector('[data-metafield="run"]');
      if (runEl && meta.run) {
        runEl.textContent = meta.run;
      }

      const specFields = ['pdga_date', 'pdga_number', 'diameter', 'height', 'rim_depth', 'rim_thickness', 'inside_rim', 'rim_ratio', 'rim_config', 'flexibility'];
      specFields.forEach(field => {
        const el = section.querySelector('[data-metafield="' + field + '"]');
        if (el && meta[field]) {
          el.innerHTML = formatSpecValue(meta[field]);
        }
      });

      const weightEl = section.querySelector('[data-metafield="max_weight"]');
      const weightLabelEl = section.querySelector('[data-metafield-label="max_weight"]');
      if (weightEl) {
        const hasRange = meta.weight_min_gr != null && meta.weight_max_gr != null;
        let weightValue = null;
        if (hasRange) {
          weightValue = meta.weight_min_gr + '–' + meta.weight_max_gr + ' GR';
        } else if (meta.max_weight) {
          weightValue = meta.max_weight;
        }
        if (weightValue) {
          weightEl.innerHTML = formatSpecValue(weightValue);
        }
        if (weightLabelEl) {
          weightLabelEl.textContent = hasRange ? 'WEIGHT' : 'MAX WEIGHT';
        }
      }

      const variantSvgEls = document.querySelectorAll('[data-variant-svg]');
      variantSvgEls.forEach((img) => {
        const key = img.dataset.variantSvg;
        if (!key) return;
        const variantSrc = meta[key];
        const fallback = img.dataset.fallbackSrc || '';
        const nextSrc = variantSrc || fallback;
        if (nextSrc && img.getAttribute('src') !== nextSrc) {
          img.setAttribute('src', nextSrc);
        }
      });

      const specContainer = section.querySelector('[data-spec-container]');
      if (specContainer && meta.spec_order) {
        const orderList = meta.spec_order.split(',').map(s => s.trim());
        const specRows = Array.from(specContainer.querySelectorAll('[data-spec-row]'));
        
        specRows.sort((a, b) => {
          const aKey = a.dataset.specRow;
          const bKey = b.dataset.specRow;
          const aIndex = orderList.indexOf(aKey);
          const bIndex = orderList.indexOf(bKey);
          
          if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
          if (aIndex !== -1) return -1;
          if (bIndex !== -1) return 1;
          const aDefault = parseInt(a.dataset.specDefaultOrder) || 999;
          const bDefault = parseInt(b.dataset.specDefaultOrder) || 999;
          return aDefault - bDefault;
        });
        
        specRows.forEach(row => specContainer.appendChild(row));
      }
    };

    const updateVariantUI = (variant) => {
      if (!variant) return;
      
      if (priceEl) {
        priceEl.textContent = formatMoney(variant);
        priceEl.dataset.price = variant.price;
      }
      
      allAddToCartBtns.forEach(btn => {
        if (variant.available) {
          btn.disabled = false;
          btn.textContent = 'ADD TO CART';
        } else {
          btn.disabled = true;
          btn.textContent = 'SOLD OUT';
        }
      });
      
      if (quantityInput && variant.inventory_quantity > 0) {
        quantityInput.max = variant.inventory_quantity;
        if (parseInt(quantityInput.value) > variant.inventory_quantity) {
          quantityInput.value = variant.inventory_quantity;
        }
      }
      
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      
      if (variant.featured_media_id && produktBilder.length && huvudbild) {
        const mediaIndex = produktBilder.findIndex((media) => String(media.id) === String(variant.featured_media_id));
        if (mediaIndex !== -1) {
          const media = produktBilder[mediaIndex];
          huvudbild.src = media.src;
          huvudbild.srcset = media.srcset;
          huvudbild.alt = media.alt;
          aktivIndex = mediaIndex;
          thumbnails.forEach((thumb) => {
            const isActive = parseInt(thumb.dataset.index, 10) === mediaIndex;
            thumb.classList.toggle('tefat-produkt__thumbnail--aktiv', isActive);
          });
          scrollMobilGalleri(mediaIndex);
        }
      } else if (variant.featured_image && huvudbild) {
        huvudbild.src = variant.featured_image;
      }
      
      updateMetafieldUI(variant);

      if (flightDiagram) {
        var activeTier = flightDiagram.dataset.flightActiveTier || 'r';
        applyFlightTier(flightDiagram, activeTier, variant);
      }
    };
    
    if (variantSelect) {
      variantSelect.addEventListener('change', (e) => {
        const variant = getVariantById(e.target.value);
        updateVariantUI(variant);
        syncVariantUiFromSelect();
      });
    }
    
    const showFeedback = (message, type = 'success') => {
      if (!feedbackEl) return;
      feedbackEl.textContent = message;
      feedbackEl.className = 'tefat-produkt__feedback tefat-produkt__feedback--' + type;
      feedbackEl.hidden = false;
      
      if (type === 'success') {
        setTimeout(() => {
          feedbackEl.hidden = true;
        }, 3000);
      }
    };
    
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const variantId = variantSelect ? variantSelect.value : form.querySelector('[name="id"]').value;
      const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
      
      allAddToCartBtns.forEach(btn => {
        btn.disabled = true;
        btn.textContent = 'ADDING...';
      });
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(variantId),
              quantity: quantity
            }]
          })
        });
        
        const data = await response.json();
        
        if (!response.ok) {
          throw new Error(data.description || 'Could not add to cart');
        }
        
        showFeedback('Added to cart!', 'success');
        allAddToCartBtns.forEach(btn => {
          btn.textContent = 'ADDED!';
        });
        
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        
        const cartCountEl = document.getElementById('tefat-cart-count');
        if (cartCountEl) {
          cartCountEl.textContent = cartData.item_count;
          cartCountEl.dataset.cartCount = cartData.item_count;
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cartData.item_count } }));
        
        const cartDrawer = document.getElementById('tefat-cart-drawer');
        if (cartDrawer) {
          try {
            const sectionResponse = await fetch('/?sections=tefat-cart');
            const sectionData = await sectionResponse.json();
            
            if (sectionData['tefat-cart']) {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = sectionData['tefat-cart'];
              const newDrawer = tempDiv.querySelector('#tefat-cart-drawer');
              
              if (newDrawer) {
                cartDrawer.innerHTML = newDrawer.innerHTML;
                if (typeof window.ScrollTrigger !== 'undefined') window.ScrollTrigger.refresh();
              }
            }
          } catch (e) {
            console.warn('Could not refresh cart drawer:', e);
          }
          
          if (window.tefatCart && typeof window.tefatCart.open === 'function') window.tefatCart.open();
        }
        
        setTimeout(() => {
          const variant = getVariantById(variantId);
          if (variant && variant.available) {
            allAddToCartBtns.forEach(btn => {
              btn.disabled = false;
              btn.textContent = 'ADD TO CART';
            });
          }
        }, 1500);
        
      } catch (error) {
        showFeedback(error.message, 'error');
        allAddToCartBtns.forEach(btn => {
          btn.disabled = false;
          btn.textContent = 'ADD TO CART';
        });
      }
    });
    
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get('variant');
    if (variantParam && variantSelect) {
      variantSelect.value = variantParam;
      const variant = getVariantById(variantParam);
      if (variant) updateVariantUI(variant);
      syncVariantUiFromSelect();
    }
  });
